import React, { useState } from "react";
import { Form, Input, Button, message, Upload } from "antd";
import RatingStars from "react-rating-stars-component";
import { useNavigate } from "react-router-dom";
import { firestore, storage } from "../../config/firebase";
import { collection, serverTimestamp, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { UploadOutlined } from "@ant-design/icons";

const AddAdvertisement = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [logo, setLogo] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [rating, setRating] = useState(0);
  const [link, setLink] = useState("");

  const handleFormSubmit = async () => {
    try {
      const newAdvertisement = {
        timestamp: serverTimestamp(),
        title,
        rating,
        description,
        link,
        active: true,
      };

      if (!newAdvertisement.rating || rating == 0) {
        form.setFields([
          {
            name: "rating", // required
            value: "", //optional
            errors: ["Rating is required"],
          },
        ]);
        return;
      }
      let ext = logo[0]?.name?.split(".");
      if (ext[1] == "svg") {
        form.setFields([
          {
            name: "logo", // required
            errors: ["SVG images are not allowed"],
          },
        ]);
        return;
      }
      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `AdvtImages/${uniqueFilename}`);
      await uploadBytes(storageRef, logo[0]);
      newAdvertisement.logo = await getDownloadURL(storageRef);
      await addDoc(collection(firestore, "advertisements"), newAdvertisement);

      form.resetFields();
      setTitle("");
      setDescription("");
      setRating(0);
      setLogo(null);
      message.success("Advertisement added successfully!");

      navigate("/advertisements");
    } catch (error) {
      console.error("Error adding new advertisement:", error);
      message.error(
        "Failed to add advertisement. Please check the form fields and try again."
      );
    }
  };


  return (
    <div style={{ maxWidth: 800, padding: 24 }}>
      <h2>Add Advertisement</h2>

      <Form
        form={form}
        onFinish={handleFormSubmit}
        initialValues={{ rating: 0}}
      >
        <Form.Item
          label="Logo"
          name="logo"
          rules={[{ required: true, message: "Upload logo!" }]}
        >
          <Upload
            beforeUpload={(file) => {
              setLogo([file]);
              return false;
            }}
            fileList={logo ? [logo[0]] : []}
            onRemove={() => setLogo(null)}
          >
            <Button icon={<UploadOutlined />}>Upload Logo</Button>
          </Upload>
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[
            { required: true, message: "Please enter the title!" },
            {
              max: 15,
              message: "Title should be maximum 15 characters!",
            },
          ]}
        >
          <Input value={title} onChange={(e) => setTitle(e.target.value)} />
        </Form.Item>

        <Form.Item
          label="Rating"
          name="rating"
          rules={[{ required: true, message: "Rating is required" }]}
        >
          <RatingStars
            count={5}
            size={24}
            value={rating}
            onChange={(newRating) => setRating(newRating)}
          />
        </Form.Item>

        <Form.Item
          label="Content description"
          name="description"
          rules={[
            {
              required: true,
              message: "Please enter content!",
            },
            {
              max: 140,
              message: "Content should be maximum 140 characters!",
            },
          ]}
        >
          <Input.TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          label="Link"
          name="link"
          rules={[{ required: true, message: "Please enter the link!" }]}
        >
          <Input value={link} onChange={(e) => setLink(e.target.value)} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Add Advertisement
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddAdvertisement;
